import { render, staticRenderFns } from "./MenuPhone.vue?vue&type=template&id=e4c0c76c&scoped=true&"
import script from "./MenuPhone.vue?vue&type=script&lang=js&"
export * from "./MenuPhone.vue?vue&type=script&lang=js&"
import style0 from "./MenuPhone.vue?vue&type=style&index=0&id=e4c0c76c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4c0c76c",
  null
  
)

export default component.exports